// BMFont使用的glow特效只能用系统字体的stroke和blur模拟
// BMFont转系统字体时，为保证参数效果一致，参数有一定调整

module.exports = FONT_DEF = {
    microsoftYahei_25_blueStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 25,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(12,129,198),
        lineWidth: 7,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_25_orangeStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 25,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(204,98,45),
        lineWidth: 7,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),
    microsoftYahei_20_orangeStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 20,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(204,98,45),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_24_blueStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 24,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(29, 112, 203),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_24_redStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 24,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(233,82,47),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    sidebox: new cc.FontDefinition((window.qq && cc.sys.os === cc.sys.OS_ANDROID)? {
        fontName: 'Microsoft YaHei',
        fontSize: 24,
        fontWeight: 'bold',
        fillStyle: cc.color(29, 112, 203),
        strokeEnabled: true,
        strokeStyle: cc.color(29, 112, 203),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }: {
        fontName: 'Microsoft YaHei',
        fontSize: 24,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(29, 112, 203),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_24_whiteStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 24,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(255, 255, 255),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_28_blueStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 28,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(29, 112, 203),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),
    
    microsoftYahei_20_brownStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 20,
        fontWeight: 'normal',
        strokeEnabled: true,
        strokeStyle: cc.color(254, 164, 41),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_30_yellowBrownStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 30,
        fontWeight: 'normal',
        strokeEnabled: true,
        strokeStyle: cc.color(245, 173, 39),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_30_deepGreen: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 24,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(81,158,19),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_30_blueBlueStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 30,
        fontWeight: 'normal',
        strokeEnabled: true,
        strokeStyle: cc.color(67, 198, 229),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_30_grayStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 30,
        fontWeight: 'normal',
        strokeEnabled: true,
        strokeStyle: cc.color(64, 64, 64),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_23_grayStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 23,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(66, 33, 33),
        lineWidth: 4,
        shadowEnabled: false,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_30_whiteStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 30,
        fontWeight: 'bold',
        strokeEnabled: true,
        strokeStyle: cc.color(255, 255, 255),
        lineWidth: 4,
        shadowEnabled: true,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),

    microsoftYahei_22_noStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 22,
        fontWeight: 'bold',
        strokeEnabled: false,
        strokeStyle: cc.color(29, 112, 203),
        lineWidth: 4,
        shadowEnabled: false,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),
    microsoftYahei_24_noStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 24,
        fontWeight: 'bold',
        strokeEnabled: false,
        strokeStyle: cc.color(29, 112, 203),
        lineWidth: 4,
        shadowEnabled: false,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),
    microsoftYahei_30_noStroke: new cc.FontDefinition({
        fontName: 'Microsoft YaHei',
        fontSize: 30,
        fontWeight: 'bold',
        strokeEnabled: false,
        strokeStyle: cc.color(29, 112, 203),
        lineWidth: 4,
        shadowEnabled: false,
        shadowBlur: 5,
        shadowOpacity: 0.5
    }),
}